import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { formatCurrency } from '../../utils/formatters';

const SectionHeader = ({ title }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <StorefrontIcon color="primary" sx={{ mr: 1 }} />
    <Typography variant="h6">{title}</Typography>
  </Box>
);

const FinancialRow = ({ label, valueBRL, valueUSD, decimals = 2 }) => (
  <TableRow>
    <TableCell component="th" scope="row">
      {label}
    </TableCell>
    <TableCell align="right">{formatCurrency(valueBRL, 'BRL', decimals)}</TableCell>
    <TableCell align="right">{formatCurrency(valueUSD, 'USD', decimals)}</TableCell>
  </TableRow>
);

/**
 * DistributionBuyerCostSection - Custo do Comprador.
 * Buyer net cost after the sale taxes the buyer can credit.
 * Buyer Credits = ICMS NF + PIS saída + COFINS saída;
 * Net Buyer Cost = sale base − Buyer Credits; Unit Buyer Cost = Net / qty.
 * Values are read directly from the OrderTaxCalculation cliente fields (BRL+USD pairs).
 */
const DistributionBuyerCostSection = ({ order }) => {
  if (!order) return null;

  const taxCalculation = order.latest_tax_calculation || {};

  const rows = [
    {
      label: 'Buyer Credits',
      brl: taxCalculation.creditos_cliente_brl,
      usd: taxCalculation.creditos_cliente_usd,
    },
    {
      label: 'Net Buyer Cost',
      brl: taxCalculation.custo_cliente_brl,
      usd: taxCalculation.custo_cliente_usd,
    },
    {
      label: 'Unit Buyer Cost',
      brl: taxCalculation.custo_unitario_cliente_brl,
      usd: taxCalculation.custo_unitario_cliente_usd,
      decimals: 4,
    },
  ];

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <SectionHeader title="BUYER COST" />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell align="right">BRL</TableCell>
                <TableCell align="right">USD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <FinancialRow
                  key={row.label}
                  label={row.label}
                  valueBRL={row.brl}
                  valueUSD={row.usd}
                  decimals={row.decimals}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default DistributionBuyerCostSection;
